import React, { useState } from 'react';
import { Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from 'mdi-react/CloseIcon';
import { checkStorage } from 'helpers/checkStorage';
const useStyles = makeStyles({
  container: {
    width: '100%',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0.5)',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000
  },

  content: {
    padding: '0.5rem',
    width: '380px',
    background: '#fff',
    borderRadius: ' 4px',
    boxShadow: '0px 8px 8px rgb(0 0 0 / 25%)'
  },
  title: {
    display: 'flex',
    justifyContent: ' space-between',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#000'
  },

  icon: {
    fill: 'gray',
    cursor: 'pointer',
    width: '20px',
    heigth: '20px'
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },

  button: {
    padding: '0.5rem',
    color: 'white',
    backgroundColor: '#0D47A1',
    fontWeight: 600,
    borderRadius: '4px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1rem',
    cursor: 'pointer',
    transition: 'background ease-in 1s',

    '&:hover': {
      backgroundColor: '#3276db'
    }
  }
});
export const AlertCookiesModal: React.FC = () => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState<boolean>(!checkStorage());

  const handleClick = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <Modal open={isOpen} BackdropComponent={'div'} className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}>
          <span>Cookies desabilitados</span>

          <CloseIcon className={classes.icon} onClick={handleClick} />
        </div>

        <p>Habilite os cookies para ter uma experiência completa em nossa plataforma</p>

        <div className={classes.buttonContainer}>
          <div className={classes.button} onClick={handleClick}>
            ok
          </div>
        </div>
      </div>
    </Modal>
  );
};
